module.exports = __webpack_public_path__ + "media/images/pattern3-da582c0f88ebc1c25dc267d9fb555b18.png";